<template>
  <div class="mt-5 text-center">
    <a
      href="/public/properties"
      class="mt-auto btn secondary-solid-btn btn-sm"
      style="background-color: #2563eb;"  
    >
       {{ $t('property_detail.property.back_to_all') }}
    </a>
  </div>
</template>
